import { Box, Paper, Stack, Typography } from "@mui/material";
import { DownloadIcon } from "../../../../../../../components/icons/DownloadIcon";
import { PdfIcon } from "../../../../../../../components/icons/PdfIcon";
import { PrintIcon} from "../../../../../../../components/icons/PrintIcon";
import { ShareIcon } from "../../../../../../../components/icons/ShareIcon";


interface PdfHeaderProps {
  onPrint?: () => void;
  onShare?: () => void;
  onDownload?: () => void;
  bookingType?: string;
}

export default function PdfHeader({
  onPrint,
  onShare,
  onDownload,
  bookingType,
}: PdfHeaderProps) {
 
  const title = bookingType ==="Conference" ? "Funeral stream proposal" : "Conference stream proposal";
  return (
    <Paper sx={{ borderRadius: 3, p: 2, boxShadow: 0, mb: 2 }}>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Stack direction="row" spacing={1.5} alignItems="center">
          <Box
            sx={{
              width: 44,
              height: 44,
              borderRadius: "8px",
              bgcolor: "#fee2e2",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <PdfIcon fontSize="large" sx={{ color: "#EF5350" }} />
          </Box>
          <Box>
            <Typography
              sx={{ fontWeight: 700, fontSize: "16px", color: "#1e293b" }}
            >
              Client View(PDF)
            </Typography>
            <Typography sx={{ fontSize: "14px", color: "#94a3b8" }}>
              {title}
            </Typography>
          </Box>
        </Stack>

        <Stack direction="row" spacing={1.5}>
          {[
            { icon: <PrintIcon sx={{ color: "#724e41", fontSize: 28 }} />, onClick: onPrint },
            { icon: <ShareIcon sx={{ color: "#724e41", fontSize: 28 }} />, onClick: onShare },
            {
              icon: <DownloadIcon sx={{ color: "#724e41", fontSize: 28 }} />,
              onClick: onDownload,
            },
          ].map((action, i) => (
            <Box
              key={i}
              onClick={action.onClick}
              sx={{
                width: 34,
                height: 34,
                borderRadius: "8px",
                bgcolor: "transparent",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
                transition: "all 0.15s",
                "&:hover": { bgcolor: "#f0f4f8", color: "#724e41" },
              }}
            >
              {action.icon}
            </Box>
          ))}
        </Stack>
      </Stack>
    </Paper>
  );
}
